import * as z from 'zod';
import { contentItemIdSchema } from '../primitives/id.js';
/**
 * Whether the app is on the screen or behind something else.
 *
 * A tablet only runs a timer while it is in front: in the background iOS
 * suspends it within seconds, and a session left open there was what made the
 * dashboard say "watching now" over a tablet that had been closed for an hour.
 */
export const deviceAppStateSchema = z.enum(['FOREGROUND', 'BACKGROUND']);
/** Where in the app the child is. */
export const deviceScreenSchema = z.enum(['HOME', 'COLLECTION', 'PLAYER', 'GAMES', 'GAME']);
/**
 * What the tablet is doing, reported with every heartbeat and the moment it
 * changes.
 *
 * Facts rather than a verdict: the device says what it sees, and the dashboard's
 * reading of them comes from `derivePresence` in `@kidshub/policy`, so the
 * meaning of "watching" has one definition rather than one per screen.
 */
export const deviceActivitySchema = z.object({
    appState: deviceAppStateSchema,
    screen: deviceScreenSchema,
    /** The video on screen is actually moving: not loading, paused or stopped. */
    isPlaying: z.boolean(),
    contentItemId: contentItemIdSchema.nullable(),
});
/**
 * What a parent is told the tablet is doing.
 *
 * `APP_CLOSED` and `OFFLINE` are both silence and are told apart by the last
 * thing the tablet said: one that went quiet after reporting it was going to
 * the background was closed or suspended; one that went quiet in the middle of
 * something lost its connection or its battery.
 */
export const devicePresenceSchema = z.enum([
    'WATCHING',
    'VIDEO_PAUSED',
    'BROWSING',
    'PLAYING_GAME',
    'BACKGROUND',
    'APP_CLOSED',
    'OFFLINE',
]);
//# sourceMappingURL=device-activity.js.map